module.exports = __webpack_public_path__ + "img/logo.b43d1b33.png";